export const OBJECT_TYPES = [
  {
    name: "flag",
    description: "classifications",
  },
  {
    name: "pubmed",
    description: "submitted publications",
  },
];

export const RESULTS_PER_PAGE = 10;
